var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraditionalCompaniesSankey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    width: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Your Diagram Title") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 600,
    width: 600,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sankey_flows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flow0",
    d: "M9 176.96012C146.25 176.96012 146.25 133.00875 283.5 133.00875",
    fill: "none",
    strokeWidth: 266.0175,
    stroke: "#595959",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Premiums \u2192 Claims: $630")), /*#__PURE__*/React.createElement("path", {
    id: "flow1",
    d: "M9 341.63762C146.25 341.63762 146.25 416.47375 283.5 416.47375",
    fill: "none",
    strokeWidth: 63.3375,
    stroke: "#d62728",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Premiums \u2192 Lost money: $150")), /*#__PURE__*/React.createElement("path", {
    id: "flow4",
    d: "M292.5 416.47375C429.75 416.47375 429.75 333.86125 567 333.86125",
    fill: "none",
    strokeWidth: 63.3375,
    stroke: "#d62728",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Gross Profit \u2192 Commissions: $150")), /*#__PURE__*/React.createElement("path", {
    id: "flow2",
    d: "M9 400.75262C146.25 400.75262 146.25 475.58875 283.5 475.58875",
    fill: "none",
    strokeWidth: 54.8925,
    stroke: "#d62728",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Premiums \u2192 Lost money: $130")), /*#__PURE__*/React.createElement("path", {
    id: "flow5",
    d: "M292.5 475.58875C429.75 475.58875 429.75 438.76375 567 438.76375",
    fill: "none",
    strokeWidth: 54.8925,
    stroke: "#d62728",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Gross Profit \u2192 Salaries: $130")), /*#__PURE__*/React.createElement("path", {
    id: "flow3",
    d: "M9 447.20012C146.25 447.20012 146.25 522.03625 283.5 522.03625",
    fill: "none",
    strokeWidth: 38.0025,
    stroke: "#d62728",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Premiums \u2192 Lost Money: $90")), /*#__PURE__*/React.createElement("path", {
    id: "flow6",
    d: "M292.5 522.03625C429.75 522.03625 429.75 542.99875 567 542.99875",
    fill: "none",
    strokeWidth: 38.0025,
    stroke: "#d62728",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("title", null, "Gross Profit \u2192 Marketing: $90"))), /*#__PURE__*/React.createElement("g", {
    id: "sankey_nodes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r0",
    className: "for_r0",
    x: 0,
    y: 43.95137,
    height: 422.25,
    width: 9,
    fill: "#17becf",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Premiums:\n1,000"))), /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r1",
    className: "for_r1",
    x: 283.5,
    y: 0,
    height: 266.0175,
    width: 9,
    fill: "#595959",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Claims:\n630"))), /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r2",
    className: "for_r2",
    x: 283.5,
    y: 384.805,
    height: 156.2325,
    width: 9,
    fill: "#d62728",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Gross Profit:\n370"))), /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r3",
    className: "for_r3",
    x: 567,
    y: 168.1925,
    height: 63.3375,
    width: 9,
    fill: "#d62728",
    fillOpacity: 1,
    transform: "translate(0,134)"
  }, /*#__PURE__*/React.createElement("title", null, "Commissions:\n150"))), /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r4",
    className: "for_r4",
    x: 567,
    y: 350.3175,
    height: 54.8925,
    width: 9,
    fill: "#d62728",
    fillOpacity: 1,
    transform: "translate(0,61)"
  }, /*#__PURE__*/React.createElement("title", null, "Salaries:\n130"))), /*#__PURE__*/React.createElement("g", {
    className: "node"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "r5",
    className: "for_r5",
    x: 567,
    y: 523.9975,
    height: 38.0025,
    width: 9,
    fill: "#d62728",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Marketing:\n90")))), /*#__PURE__*/React.createElement("g", {
    id: "sankey_labels",
    fontFamily: "sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "label0_bg",
    className: "for_r0",
    x: 10.6327,
    y: 243.04138,
    width: 138.66704,
    height: 23.3,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "label0",
    className: "for_r0",
    textAnchor: "start",
    x: 14.29754,
    y: 255.07637,
    dy: 5.364999999999999
  }, "Premiums: $1,000"), /*#__PURE__*/React.createElement("rect", {
    id: "label1_bg",
    className: "for_r1",
    x: 177.6612,
    y: 120.97375,
    width: 104.20609,
    height: 23.3,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "label1",
    className: "for_r1",
    textAnchor: "end",
    x: 277.20246,
    y: 133.00875,
    dy: 5.364999999999999
  }, "Claims: $630"), /*#__PURE__*/React.createElement("rect", {
    id: "label2_bg",
    className: "for_r2",
    x: 142.09089,
    y: 450.88625,
    width: 139.77641,
    height: 23.3,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "label2",
    className: "for_r2",
    textAnchor: "end",
    x: 277.20246,
    y: 462.92125,
    dy: 5.364999999999999
  }, "Lost Money: $370"), /*#__PURE__*/React.createElement("rect", {
    id: "label3_bg",
    className: "for_r3",
    x: 414.0362,
    y: 187.82626,
    width: 151.33109,
    height: 23.3,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0,
    transform: "translate(0,134)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "label3",
    className: "for_r3",
    textAnchor: "end",
    x: 560.70246,
    y: 199.86125,
    dy: 5.364999999999999,
    transform: "translate(0,134)"
  }, "Commissions: $150"), /*#__PURE__*/React.createElement("rect", {
    id: "label4_bg",
    className: "for_r4",
    x: 452.24714,
    y: 365.72875,
    width: 113.12016,
    height: 23.3,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0,
    transform: "translate(0,61)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "label4",
    className: "for_r4",
    textAnchor: "end",
    x: 560.70246,
    y: 377.76375,
    dy: 5.364999999999999,
    transform: "translate(0,61)"
  }, "Salaries: $130"), /*#__PURE__*/React.createElement("rect", {
    id: "label5_bg",
    className: "for_r5",
    x: 448.70027,
    y: 530.96377,
    width: 116.66703,
    height: 23.33906,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.55,
    stroke: "none",
    strokeWidth: 0,
    strokeOpacity: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "label5",
    className: "for_r5",
    textAnchor: "end",
    x: 560.70246,
    y: 542.99875,
    dy: 5.364999999999999
  }, "Marketing: $90")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraditionalCompaniesSankey);
export default __webpack_public_path__ + "static/media/traditional_companies_sankey.ea6cf8077251ba9847f86249c42631b2.svg";
export { ForwardRef as ReactComponent };